<template>
    <Head>
        <title>Pembayaran Tertangguh</title>
    </Head>
    <div class="container">
        <div class="card mt-5 w-100">
            <div class="card-body">
                <div class="alert alert-warning">
                    <p class="fs-4 fw-bold text-center"><i class="fa-solid fa-circle-info me-2"></i> Pembayaran Tertangguh</p>
                </div>
                <p class="card-text">Sila selesaikan pembayaran anda di kedai fizikal pilihan pembayaran anda. Anda perlulah menyelesaikan dalam
                    tempoh <strong>48 jam dari sekarang atau pembayaran anda tidak berjaya</strong>. Anda boleh lihat resit pembayaran yang berjaya di ezid.my. Anda boleh tekan butang <strong>"X"</strong> pada pelayar anda untuk tutup</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import {Head} from "@inertiajs/vue3";
let wrazer = ref();
const data = defineProps<{
    uridel: string,
    uritry: string,
    razeripn: string,
    tokenizer: string,
}>();

onMounted(()=>{
    let m = document.createElement('IFRAME');
    m.setAttribute('src', data.razeripn);
    m.setAttribute('seamless', 'seamless');
    m.setAttribute('width', String(0));
    m.setAttribute('height', String(0));
    m.setAttribute('frameborder', String(0));
    m.setAttribute('scrolling', 'no');
    m.setAttribute('style', 'border:none !important;');
    document.body.appendChild(m);
});
</script>
